import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
 import { BehaviorSubject } from 'rxjs';
import { ToastType } from '../models/toast-types.enum';
 
@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private _snackBar: MatSnackBar) { }

  public CurrentMenu: BehaviorSubject<any> = new BehaviorSubject(null);
  public CurrentMenu$ = this.CurrentMenu.asObservable();
  public CurrentSite: BehaviorSubject<any> = new BehaviorSubject(null);
  public CurrentSite$ = this.CurrentSite.asObservable();



  public disconnect() {
    this.CurrentMenu = new BehaviorSubject<any>(null);
    this.CurrentMenu$ = this.CurrentMenu.asObservable();
    this.CurrentSite = new BehaviorSubject<any>(null);
    this.CurrentSite$ = this.CurrentSite.asObservable();
  }

  setCurrentMenu(menu) {
    this.CurrentMenu.next(menu);
  }

  setCurrentSite(site) {
    this.CurrentSite.next(site);
  }
  public openSnackBar(message: string,type:ToastType) {
    this._snackBar.open(message, '', {
      duration: 2000,
      panelClass:[type]
    });
  }

}
